var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9678 30.0003L38.5055 26.2629L41.6893 18.133L33.612 21.2937L29.8169 6.66699L26.0204 21.2951L17.943 18.1344L21.1276 26.2643L8.66602 30.0003L21.129 33.7377L17.9444 41.8677L26.0225 38.7069L29.8169 53.3337L33.6134 38.7069L41.6908 41.8677L38.5069 33.7377L50.9678 30.0003Z",
    fill: "url(#paint0_linear_5150_3843)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5150_3843",
    x1: 50.666,
    y1: 6.66699,
    x2: 29.8169,
    y2: 53.3337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9898"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpark);
export default __webpack_public_path__ + "static/media/spark.6875a0d17b08ed887ffcf028c1bb0048.svg";
export { ForwardRef as ReactComponent };